<template>
    <el-dialog title="选择证照" :visible.sync="dialogVisible" :center="true" width="1100px" :before-close="cancel" :close-on-click-modal="false">
        <div class="content">
            <div class="header">
                <!-- <div class="left">
                    <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
                </div> -->
                <div class="right">
                    <div class="search">
                        <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
                            <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
                        </el-input>
                    </div>
                    <span v-preventReClick @click="reset">重置</span>
                </div>
            </div>
            <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <template slot="empty">
                    <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                        <img src="../../../../assets/noData.png" width="240" height="240" />
                        <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                        <div class="empty-rest" @click="reset">恢复默认</div>
                    </div>
                </template>
                <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
                </el-table-column>
                <el-table-column prop="no" label="批准文号" min-width="180"></el-table-column>
                <el-table-column prop="name" label="注册证名称" min-width="100">
                </el-table-column>
                <el-table-column prop="effectDate" label="生效日期" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ parseTime(new Date(scope.row.effectDate), "{y}-{m}-{d}") }}
                    </template>
                </el-table-column>
                <el-table-column prop="invalidDate" label="失效日期" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ parseTime(new Date(scope.row.invalidDate), "{y}-{m}-{d}") }}
                    </template>
                </el-table-column>
                <el-table-column prop="manufacturerName" label="生产厂家" min-width="180"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
            <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {
    SaveProductRegistCert,
    GetProductRegistCerts,
    GetProductRegistCertById,
    RemoveProductRegistCerts,
} from "@/api";
import {
  WarehouseTypeOptions,
} from "@/enum";
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectFilter from "@/components/table-select-filter";

export default {
    mixins: [GetDataMixin],
    props: {
        open:{
            type:Boolean,
            default:false
        },
        filterIds:{
            type:Array,
            default:[]
        }
    },
    components: {
        SelectFilter    
    },
   data () {
       return {
        dialogVisible:false,
        WarehouseTypeOptions:WarehouseTypeOptions,
        // 查询条件
        query: {
            keyWord: "",
            pageSize: 10,
            pageIndex: 1,
            SourceType:2
        },
        // 列表数据
        tableData: [],
        // 列表总数
        total: 0,
        // 多选框数据
        ids: [],
        multipleSelection: [],
        // 列表多选
        multiple: true,
       }
   },
   methods:{
    // 关闭注册证
    cancel () {
        this.dialogVisible = false
        this.$emit('dialogVisible',this.dialogVisible )
    },
    // 保存
    submit () {
        this.$emit('chooseIds',this.ids )
        this.cancel()
    },
    handleSelectionChange(selection) {
        this.multipleSelection = selection;
        this.ids = selection.map((item) => item.id);
        this.multiple = !selection.length;
    },
    // 获取列表
    getData() {
        this.query.notIds = this.filterIds
        this.query.SourceType= 2
        GetProductRegistCerts(this.query).then((res) => {
            this.tableData = res.returnData.data;
            this.total = res.returnData.totalCount;
        });
    },
     // 改变当前页
     changePage(val) {
        this.$set(this.query, "pageIndex", val);
        this.getData();
    },
    handleSizeChange(val) {
        this.$set(this.query, "pageSize", val);
        this.getData();
    },
    // 重置
    reset() {
        this.query.keyWord = "";
        this.$set(this.query, "pageIndex", 1);
        this.$set(this.query, "pageSize", 10);
        this.ids = []
        this.multipleSelection = []
        this.multiple = true;
        if (this.$refs["selectFilter"]) {
            this.$refs["selectFilter"].resetQuery();
        }

        if (this.$refs.multipleTable) {
            this.$refs.multipleTable.clearSelection()
        }
        this.getData();
    },
    queryChange() {
        this.$set(this.query, "pageIndex", 1);
        this.getData();
    },
    filterChange (query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },
   },
   mounted () {
    this.dialogVisible = this.open
    this.getData();
   },
};
</script>
<style lang="scss" scoped>
.manageRange {
    width: 100%;
    max-height: 120px;
    overflow-x: hidden;

    /deep/.el-select__tags {
        max-height: 120px !important;
    }
}

.oldProduction {}
/deep/.el-dialog__body{
    flex: 1;
    height: 0;
}
/deep/.select-content{
    width: 1064px !important;
}
.pagination{
    margin-top: 10px;
}
.content{
    height: 100%;
    display: flex;
    flex-direction: column;
}
/deep/.el-dialog{
    height: 90%;
    .el-table{
        flex: 1;
        height: 0;
        overflow-y: scroll;
    }
}
</style>
